import {
  SAVE_CONTACTS_LIST,
  SAVE_CONTACT_DETAILS
} from 'redux/constants/Contacts';
  
const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_CONTACTS_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_CONTACT_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};
  
export default theme